import {axios as http} from "@/plugins/http"

export default class Api {
    static categories() {
        return http.get('/api/v1/catalog/list')
    }
}
